export const LOCAL_STORAGE_LANGUAGE = "language";

export const SESSION_STORAGE_PATH = "path";
export const SESSION_STORAGE_UUID = "uuid";
